import image1 from "../images/slider01.jpg"
import image2 from "../images/slider02.jpg"
import image3 from "../images/slider03.jpg"
import image4 from "../images/Mask-1.jpg"
import new4 from "../images/new4.jpg"
import new5 from "../images/ha1.jpg"
import new6 from "../images/ok1.jpg"
import new7 from "../images/new2.jpg"

import bed from "../images/bed.jpg"
import chair from "../images/chair.jpg"
import table from "../images/table.jpg"
import bed1 from "../images/bed1.jpg"
import bed2 from "../images/bed2.jpg"


import grid1 from "../images/3.jpg";
import grid2 from "../images/ha1.jpg"
import grid3 from "../images/ok1.jpg";




export const dataImageHome = [new4];

export const HomeGrid = [
    {
        title: 'City Living With Country Character.',
        location: 'Kampala',
        image: image1,
        classename: 'image0'
    },
    {
        title: 'Modern Living in Tight Urban Spaces.',
        location: 'Kampala',
        image: image2,
        classename: 'image1'
    },
    {
        title: 'Riverside Apartment With Stunning Views.',
        location: 'Kampala',
        image: new7
        , classename: 'image2'
    },
    {
        title: 'Old World Meets New World Appartment.',
        location: 'Kampala',
        image: new5
        , classename: 'image3'
    },
    {
        title: 'Modern Living in Tight Urban Spaces',
        location: 'Kampala',
        image: new6
        , classename: 'image4'
    },

    {
        title: 'Modern Living in Tight Urban Spaces',
        location: 'Kampala',
        image: table,
        classename: 'image6'
    },
]

export const dataGridImage = [
    {
        title: '',
        image: image1,
        location: 'Kampala'
    },
    {
        title: '',
        image: image2,
        location: 'Kampala'
    },
    {
        title: '',
        image: image3,
        location: 'Kampala'
    },

    {
        title: '',
        image: image4,
        location: 'Kampala'
    },
    {
        title: '',
        image: grid1,
        location: 'Kampala'
    },
    {
        title: '',
        image: grid2,
        location: 'Kampala'
    },
    {
        title: '',
        image: grid3,
        location: 'Kampala'
    },
    {
        title: '',
        image: table,
        location: 'Kampala'
    },
    {
        title: '',
        image: bed2,
        location: 'Kampala'
    }, {
        title: '',
        image: bed1,
        location: 'Kampala'
    }, {
        title: '',
        image: bed,
        location: 'Kampala'
    }, {
        title: '',
        image: chair,
        location: 'Kampala'
    },
]
export const dataImage = [
    {
        title: '',
        description: 'box-shadow CSS generator that helps you quickly generate box-shadowA box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily gA box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily get fonts at Font Keyboard iOS app and Font Keyboard Android app.onts at Font Keyboard iOS app and Font Keyboar',
    },
    {
        title: '',
        description: 'box-shadow CSS generator that helps you quickly generate box-shadowA box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily gA box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily get fonts at Font Keyboard iOS app and Font Keyboard Android app.onts at Font Keyboard iOS app and Font Keyboar',
    },
    {
        title: '',
        description: 'box-shadow CSS generator that helps you quickly generate box-shadowA box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily gA box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily get fonts at Font Keyboard iOS app and Font Keyboard Android app.onts at Font Keyboard iOS app and Font Keyboar',
    },
];

export const Para = [
    {
        title: 'Unkown',
        image: image1,
        alt: 'unkownn',

    },
    {
        title: 'Unkown',
        image: image2,
        alt: 'unkownn',

    },
    {
        title: 'Unkown',
        image: image3,
        alt: 'unkownn',

    },
    {
        title: 'Unkown',
        image: image4,
        alt: 'unkownn',

    },

]